import React, { useState, useEffect } from "react";
import {

  Accordion,


  Col,

  Row,

} from "reactstrap";

import { useSelector } from "react-redux";
import Favourite_Prompt_Accordian from "./Favourite_Prompt_Accordian";
import Loader from "../../Components/Common/Loader";
import { waitForDecision } from "../../utility/wait_for_confirmation";
import { useDispatch } from "react-redux";
import { Delete_Fav_Prompt, Get_Favourite_Prompt_Category, Get_Favourite_Prompt_List } from "../../slices/thunks";
import { close_confirm_modal, open_confirm_modal } from "../../slices/Confirm_Modal/reducer";


const FavoritePrompt = ({ }) => {
   const dispatch = useDispatch();

  // Favorite Prompt
  const { Favourite_Prompt_List, Favorite_Prompt_Category, loading } =
    useSelector((state) => state.Favourite_Prompt);
    const { Assets_ID , Bot_ID , Group_ID } = useSelector((state) => state.BotDetails.Bot_Details);
  const [
    structured_data_for_favourite_prompt,
    setstructured_data_for_favourite_prompt,
  ] = useState([]);

  useEffect(() => {
    let temp_fav_prompt = [];

    // console.log( "Prompt List")
    // console.log(Favourite_Prompt_List , "dATA");
    
    let 
    Favorite_Prompt_Category_with_blank = [...Favorite_Prompt_Category,"" ]
    

    Favorite_Prompt_Category_with_blank.forEach((category) => {
      let fav_prompt = [];
     
      Favourite_Prompt_List.forEach((fav_promt_) => {
    
        
          
        if (fav_promt_.Prompt_Category.trim() === category.trim()) {
          fav_prompt.push(fav_promt_);
        }
      });

      if (fav_prompt.length !== 0) {
        temp_fav_prompt.push({
          Favourite_Prompt_Category: category==""?"No Category":category,
          Favorite_Prompt: fav_prompt,
        });
      }
    });
  
    
    setstructured_data_for_favourite_prompt(temp_fav_prompt);
  }, [Favourite_Prompt_List, Favorite_Prompt_Category]);



  const delete_fav_prompt= async(Bot_Favorite_Prompt_ID )=>{
         
  
       dispatch(open_confirm_modal("Are you sure you want to delete this Prompt?"))
       const decision = await waitForDecision();
       if(decision){
        dispatch(Delete_Fav_Prompt({ Bot_Favorite_Prompt_ID , Bot_ID:Bot_ID}))
   
      }
      dispatch(close_confirm_modal())
  }



  
  const [isActive, setIsActive] = useState(false);
  const [isUp, setIsUp] = useState(false);
  const handleToggle = () => {
    setIsActive((prev) => !prev); // Toggle the state
    setIsUp((prev) => !prev);
  };


  useEffect(() => {
  const resolvedBotId =  Bot_ID;
    if (!resolvedBotId) return;

    // Lists dependent on Bot
    dispatch(Get_Favourite_Prompt_List({ Bot_ID: resolvedBotId }));
    // dispatch(Get_Bot_User_List({ bot_id: resolvedBotId }));

    // Group-dependent data
    if (Group_ID) {
      // dispatch(group_owner_details({ group_id: BotDetails.Group_ID , page:1 , per_page:1 }));
      dispatch(Get_Favourite_Prompt_Category({ group_id: Group_ID }));
    }
  }, [Bot_ID])
  

  return (
    <div className="botthreads">
      <Row>

        <Col lg={5}>
          {/* <span>
                        <div className="input-group"><Input placeholder="Search Bot name" aria-label="Recipient's username with two button addons" type="text" class="form-control h-40 form-control" />
                        <button className="btn btn-primary padd_10" type="button"><i className="bx bx-search fs-20"></i></button></div>
                    </span> */}
        </Col>
      </Row>
      <div className='mob-view' style={{marginBottom: '15px'}}>                
                <button  className="text-body-secondary" onClick={handleToggle} style={{border:'none', backgroundColor:'transparent'}}> Favourite Prompt
                  <i style={{fontSize:'14px'}} className={isUp ? "ri-arrow-drop-down-line" : "ri-arrow-drop-up-line"}></i></button>                               
              </div>
      <div className={isActive ? "ns-mob active" : "ns-mob"}>
      {loading?<Loader/>:<Row>
        <Col>
          <Accordion id="default-accordion-example">
            {structured_data_for_favourite_prompt.map(
              (Fav_Prompt_Structured, index) => {
                const { Favourite_Prompt_Category, Favorite_Prompt } =
                  Fav_Prompt_Structured;
                return (
                    <Favourite_Prompt_Accordian delete_fav_prompt={delete_fav_prompt} key={index}  Favourite_Prompt_Category={Favourite_Prompt_Category} Favorite_Prompt={Favorite_Prompt}  />
            
                );
              }
            )}
          </Accordion>
        </Col>
      </Row>}
      </div>
    </div>
  );
};

export default FavoritePrompt;
